const stripHexPrefix= require('strip-hex-prefix');

module.exports = function getTransactionReceiptMined(txHash, interval,callback) {
    const self = this;
    const transactionReceiptAsync = function(resolve, reject) {
        self.getTransactionReceipt(txHash, (error, receipt) => {
            if (error) {
                reject(error);
            } else if (receipt == null) {
                setTimeout(
                    () => transactionReceiptAsync(resolve, reject),
                    interval ? interval : 500);
            } else {
                if(stripHexPrefix(receipt.status) === '1'){
                    return callback({
                        receipt: receipt,
                        txStatus: 1
                    });
                }
                else{
                    return callback({
                        txStatus: 0
                    })
                }
            }
        });
    };

    if (Array.isArray(txHash)) {
        return Promise.all(txHash.map(
            oneTxHash => self.getTransactionReceiptMined(oneTxHash, interval)));
    } else if (typeof txHash === "string") {
        return new Promise(transactionReceiptAsync);
    } else {
        throw new Error("Invalid Type: " + txHash);
    }
};


// WEBPACK FOOTER //
// ./src/components/transactionReceipt.js